export default {
  title: '商品詳情',
  isDisposals: '處分品',
  productStocknumTag: '庫存緊張',
  brandName: '品牌',
  countryOfOrigin: '原產地',
  productNo: '編號',
  productPointNum: '贈送積分',
  couponTags: '優惠券',
  activityTitles: '促銷',
  specValueName: '已選規格',
  dispatchInfo: '配送至',
  receiveDate: '最快送達日 {date}',
  transportName: '運輸',
  evaluateTitle: '商品評價',
  evaluateAll: '查看全部',
  evaluateAllBottom: '查看全部',
  evaluateNoList: '暫無評論',
  productDesc: '商品描述',
  productNoDesc: '暫無商品資訊哦~~',
  btnProductStatus: '已下架',
  btnInventoryQuantity: '到貨通知',
  btnAddCart: '加入購物車',
  proNum: '數量',
  inventoryQuantity: '對不起，該商品暫無庫存！',
  mpContent: '請關註{name}微信公眾號後留言。',
  mpBtn: '複製公眾號名稱',
  serverTitle: '客戶服務',
  mycouponTitle: '已領取',
  availableCoupon: '可領取',
  couponType1: '滿減券',
  couponType2: '滿折券',
  couponType3: '運費抵用券',
  couponType1UseMoney_text1: '满',
  couponType1UseMoney_text2: '减',
  couponType1NoUseMoney: '任意金额减',
  couponType2UseMoney: '享{discountInfo}%OFF',
  couponType2NoUseMoney: '任意金额享{discountInfo}%OFF',
  couponType3UseMoney: '包邮{discountInfo}',
  couponType3NoUseMoney: '任意金额包邮{discountInfo}',
  freeTransportName: '免運費{freetransportName}',
  couponProductType: '部分商品可使用',
  freeTransportType: '{freeTransportAreaName}免運費',
  freeTransportTypeYw: '{freeTransportAreaName}以外免運費',
  receiveNum: '限領{num}張',
  useDate: '有效期',
  dateInterval: '至',
  dateSameDay: '領券當日開始',
  dateNextDay: '領券次日開始',
  valiateDay: '天內有效',
  receive: '領取',
  toUse: '去使用',
  CouponSuccess: '領取成功',
  CollectSuccess: '收藏成功!',
  specsConfirmSuccess: '申請到貨通知成功',
  activitTextStart: '距活動開始還有',
  activitTextEnd: '距活動結束還有',
  RelatedList: '相關商品',
  HistoryList: '瀏覽記錄',
  noProduct: '沒有找到您想要的商品哦！',
  tips: '系統會根據您的配送地址預估最快送達日。您還可以在結帳頁面指定收貨時間，本服務完全免費。如遇不可抗力因素，如天候，交通狀況等有延遲配達可能，還望理解。',
  allcouponProductType: '全部商品可始使用',
  copySuccess: '複製成功'
};